import { ApiPaths } from './ApiPaths';
import BaseApi from './BaseApi'

/**
 * API for retrieving user account info using apisauce
*/
const create = () => {

    const api = BaseApi.create();
``
    const getAccountInfo = () => api.get(ApiPaths.ACCOUNT_INFO);

    const saveAccountInfo = (payload) => api.post(ApiPaths.ACCOUNT_INFO, payload);

    const finalizeSignIn = () => api.get(ApiPaths.FINALIZE_SIGN_IN);

    // Return back a collection of functions
    return { finalizeSignIn, getAccountInfo, saveAccountInfo }
}

// let's return back our create method as the default.
export default {
    create
}

